export const OKCLAW_INVOICE_REQUEST_TIMEOUT_MS = 30_000
// Authentication recovery can run the first request, token refresh, and replay sequentially.
export const OKCLAW_INVOICE_AUTH_RECOVERY_TIMEOUT_MS = OKCLAW_INVOICE_REQUEST_TIMEOUT_MS * 3
export const OKCLAW_INVOICE_FILE_DOWNLOAD_TIMEOUT_MS = 30_000
export const OKCLAW_INVOICE_DOWNLOAD_FLOW_TIMEOUT_MS = (
  OKCLAW_INVOICE_AUTH_RECOVERY_TIMEOUT_MS + OKCLAW_INVOICE_FILE_DOWNLOAD_TIMEOUT_MS
)

// Server and client deadlines leave separate processing and transport margins outside domain work.
export const OKCLAW_INVOICE_SERVER_TIMEOUT_MS = 120_000
export const OKCLAW_INVOICE_CLIENT_TIMEOUT_MS = 150_000
export const OKCLAW_INVOICE_DOWNLOAD_SERVER_TIMEOUT_MS = 150_000
export const OKCLAW_INVOICE_DOWNLOAD_CLIENT_TIMEOUT_MS = 180_000
